import { PARTNER } from "@tm/isomorphic-utils";
import { FormattedText, ImageComponent, SpanTag } from "@tm/static";
import { usePartnerContext } from "@tm/static/partnerContext";
import React from "react";

import { isEmpty } from "lodash";
import { OrderRightHd } from "../../../../components/OrderDetailRightComp/OrderDetailRightComp.style";
import { useOrderActions } from "../../hooks/useOrderActions";
import { Card, CardPadding } from "../../OrderDetailV2.style";
import type { OrderDetailV2ForInsuranceProps } from "../../types";
import {
  ButtonIcon,
  ButtonText,
  ItemButton,
  ItemsContainer,
} from "./OrderDetailV2ForInsurance.style";

export const OrderDetailV2ForInsurance: React.FC<
  OrderDetailV2ForInsuranceProps
> = ({ title, items, actionsConfig }) => {
  const { executeAction } = useOrderActions(actionsConfig);
  const partner = usePartnerContext();
  const isGI = partner === PARTNER.GI;

  if (isEmpty(items)) {
    return null;
  }

  return (
    <Card>
      {title && (
        <OrderRightHd>
          <SpanTag fontWeight="bold" fontSize="md">
            <FormattedText value={title} />
          </SpanTag>
        </OrderRightHd>
      )}
      <CardPadding>
        <ItemsContainer isGI={isGI}>
          {items.map((item, index) => (
            <ItemButton
              key={`${item.sectionType}-${index}`}
              isDisabled={item.isDisabled}
              isGI={isGI}
              onClick={() => executeAction(item.sectionType)}
              disabled={item.isDisabled}
              aria-label={item.title}
            >
              <ButtonIcon isDisabled={item.isDisabled}>
                <ImageComponent width="20px" height="20px" src={item.icon} />
              </ButtonIcon>
              <ButtonText>
                <FormattedText value={item.title} />
              </ButtonText>
            </ItemButton>
          ))}
        </ItemsContainer>
      </CardPadding>
    </Card>
  );
};
